import React from "react";
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";
import useBalancedColumns from "../../hooks/useBalancedColumns";

const SHAPE_PREVIEW_STYLES = {
  rectangle: {},
  circle: { borderRadius: "50%" },
  square: { aspectRatio: "1 / 1" },
  oval: { borderRadius: "50% / 25%" },
  diamond: { clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)" },
  hexagon: {
    clipPath:
      "polygon(25% 6.7%, 75% 6.7%, 100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%)",
  },
  triangle: { clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" },
  star: {
    clipPath:
      "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
  },
};

const DEFAULT_CHOICES = [
  { value: "rectangle", label: "Rectangle" },
  { value: "circle", label: "Circle" },
  { value: "square", label: "Square" },
  { value: "oval", label: "Oval" },
  { value: "star", label: "Star" },
  { value: "diamond", label: "Diamond" },
  { value: "hexagon", label: "Hexagon" },
  { value: "triangle", label: "Triangle" },
];

export default function ImageShapeField({ label, help, value, onChange, choices, infoText }) {
  const opts = Array.isArray(choices) && choices.length
    ? choices.map((c) => ({ value: c.value, label: c.label }))
    : DEFAULT_CHOICES;

  const normalized = (value || "rectangle");

  const [gridRef, columns] = useBalancedColumns(opts.length, { minItemWidth: 85, gap: 8 });

  return (
    <div className="field-wrapper">
      {label && (
        <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>
          {label}
        </label>
      )}

      <div ref={gridRef} className="grid gap-2" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
        {opts.map((opt) => {
          const selected = normalized === opt.value;
          const shapeStyle = SHAPE_PREVIEW_STYLES[opt.value] || {};
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={`flex flex-col items-center p-3 border rounded-lg transition-all ${
                selected 
                  ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm` 
                  : `${borders.default} ${surfaces.tertiary} ${surfaces.hover}`
              }`}
              title={opt.label}
            >
              {/* Shape preview container */}
              <div className="w-full h-12 flex items-center justify-center mb-2">
                <div
                  className={selected ? "text-white/80" : "text-gray-400 dark:text-dark-400"}
                  style={{
                    width: "48px",
                    height: "48px",
                    background: "currentColor",
                    ...shapeStyle,
                  }}
                />
              </div>
              <span className={`${typography.caption} ${selected ? "text-white" : textColors.primary}`}>
                {opt.label}
              </span>
            </button>
          );
        })}
      </div>

      {help && (
        <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>
          {help}
        </div>
      )}
    </div>
  );
}


